// Generate a unique device ID using UUID4
const generateDeviceId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Get or create device ID from localStorage
export const getDeviceId = () => {
  try {
    // Check if device ID exists in localStorage
    let deviceId = localStorage.getItem('device_id');
    
    if (!deviceId) {
      // Generate new device ID if none exists
      deviceId = generateDeviceId();
      localStorage.setItem('device_id', deviceId);
      // ...existing code...
    } else {
      // ...existing code...
    }
    
    return deviceId;
  } catch (error) {
    // ...existing code...
    // Fallback to generating a new ID if localStorage is not available
    return generateDeviceId();
  }
};

// Clear device ID (useful for testing or when user wants to reset)
export const clearDeviceId = () => {
  try {
    localStorage.removeItem('device_id');
    // ...existing code...
  } catch (error) {
    // ...existing code...
  }
};